import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addRentalPlan = (planData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_RENTAL_PLAN_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/resale-plan/plan-add`,
        planData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_RENTAL_PLAN_SUCCESS", payload: data });
        toast.success("Rental Plan Added successfully!");
      } else {
        dispatch({ type: "ADD_RENTAL_PLAN_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "ADD_RENTAL_PLAN_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listRentalPlans = (pageData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_RENTAL_PLANS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/resale-plan/plan-list`,
        pageData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_RENTAL_PLANS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_RENTAL_PLANS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_RENTAL_PLANS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewRentalPlan = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_RENTAL_PLAN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/resale-plan/view-plan/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_RENTAL_PLAN_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_RENTAL_PLAN_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "VIEW_RENTAL_PLAN_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateRentalPlan = (planData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_RENTAL_PLAN_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/resale-plan/plan-update`,
        planData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_PLAN_SUCCESS", payload: data });
        toast.success("Rental Plan Updated successfully!");
      } else {
        dispatch({ type: "UPDATE_RENTAL_PLAN_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_PLAN_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateRentalPlanStatus = (statusData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_RENTAL_PLAN_STATUS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/resale-plan/plan-status`,
        statusData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_PLAN_STATUS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "UPDATE_RENTAL_PLAN_STATUS_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_PLAN_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};